<template>
<v-card elevation="0" class="pa-2 mx-10" min-height="790" max-height="790">
    <v-row>
        <v-col >
            <v-card-title>Filter Item Statistic of current: {{this.filterCounter}}</v-card-title>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="0" sm="0" md="0">
            <v-row>
                <v-col cols="0" sm="0" md="0">
                    <v-card
                            class="pt-4 pl-4 my-0"
                            min-width="350"
                            max-width="350"
                            elevation="1"
                            outlined
                    >
                        <div class="font-weight-black pb-0">By Battle item type</div>
                        <v-container
                        >
                            <v-data-table
                                    :headers="battleHeaders"
                                    :items="battleList"
                                    class="scrollable-table-medium"
                                    hide-default-footer
                                    hide-default-header
                            >
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="0" sm="0" md="0" class="pl-0 pt-3">
                    <v-card
                            class="pt-4 pl-4 my-0"
                            min-width="350"
                            max-width="350"
                            elevation="1"
                            outlined
                    >
                        <div class="font-weight-black pb-0">By Category item type</div>
                        <v-container
                        >
                            <v-data-table
                                    :headers="categoryHeaders"
                                    :items="categoryList"
                                    class="scrollable-table-large"
                                    hide-default-footer
                                    fixed-header
                            >
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="0" sm="0" md="0" class="pl-4 pt-0">
            <v-row>
                <v-col cols="0" sm="0" md="0" class="pl-5 pt-0">
                    <v-card
                            class="pt-4 pl-4 my-0"
                            min-width="480"
                            max-width="480"
                            elevation="1"
                            outlined
                    >
                        <div class="font-weight-black pb-0">By Impact item type</div>
                        <v-container
                        >
                            <v-data-table
                                    :headers="impactHeaders"
                                    :items="impactList"
                                    class="scrollable-table-large"
                                    hide-default-footer
                                    :items-per-page="impactList.length"
                                    fixed-header
                            >
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</v-card>
</template>

<script>
    import ItemType from "../../constants/ItemTypeConstants.js";
    import ItemFilterUtils from "../../Utils/ItemFilterUtils";
    import {BehaviourByNames} from "@/item-editor/constants/BehaviourTypes";

    export default {
        name: "UnityEnvironmentConfig",
        props: ['pItemList'],
        data() {
            return {
                battleList: [],
                battleHeaders: [
                    {text: 'Battle type', value: 'type'},
                    {text: 'Counter', value: 'count'},
                    {text: 'Percentage', value: 'percent'},
                ],

                impactList: [],
                impactHeaders: [
                    {text: 'Impact', value: 'impact'},
                    {text: 'Counter', value: 'count'},
                    {text: 'Percentage', value: 'percent'},
                ],

                categoryList: [],
                categoryHeaders: [
                    {text: 'Category', value: 'category'},
                    {text: 'Counter', value: 'count'},
                    {text: 'Percentage', value: 'percent'},
                ],

                filterCounter: 0,
            }
        },
        created() {
            this.init();
        },
        methods: {
            init(){
                this.filterCounter = this.pItemList.length;
                console.log(this.pItemList);
                this.initByBattleType();
                this.initByCategory();
                this.initByImpact();
            },

            initByBattleType(){
                this.addBattleTypeToList("defense");
                this.addBattleTypeToList("attack");
                this.addBattleTypeToList("health");
            },

            addBattleTypeToList(type){
                let colors = ItemType.ItemBattleShortcutAndColors[type];
                let count = this.pItemList.filter(i => colors.includes(i.color)).length;
                this.battleList.push({
                    type: type,
                    count: count,
                    percent: this.getPercentView(count)
                });
            },

            initByCategory() {
                this.addCategoryToList('ensign');
                this.addCategoryToList('glove');
                this.addCategoryToList('lantern');
                this.addCategoryToList('potion');
                this.addCategoryToList('ring');
                this.addCategoryToList('scroll');
                this.addCategoryToList('shield');
                this.addCategoryToList('weapon');
            },

            addCategoryToList(type){
                let count = this.pItemList.filter(i => i.category === type).length;
                this.categoryList.push({
                    category: type,
                    count: count,
                    percent: this.getPercentView((count))
                });
            },

            initByImpact() {
                this.addImpactToList(BehaviourByNames.damageEnemy);
                this.addImpactToList(BehaviourByNames.incHp);
                this.addImpactToList(BehaviourByNames.fillHp);
                this.addImpactToList(BehaviourByNames.incDps);
                this.addImpactToList(BehaviourByNames.incSpeedSupport);
                this.addImpactToList(BehaviourByNames.incCriticalHitRatio);
                this.addImpactToList(BehaviourByNames.reviveSupport);
                this.addImpactToList(BehaviourByNames.reviveHero);
                this.addImpactToList(BehaviourByNames.incGoldEnemyDrop);
                this.addImpactToList(BehaviourByNames.incGoldDrop);
                this.addImpactToList(BehaviourByNames.fillMana);
                this.addImpactToList(BehaviourByNames.incManaRefillSpeed);
                this.addImpactToList(BehaviourByNames.incMana);
                this.addImpactToList(BehaviourByNames.incPowerUpCapacity);
                this.addImpactToList(BehaviourByNames.incPetActiveTime);
                this.addImpactToList(BehaviourByNames.freezeEnemy);
                this.addImpactToList(BehaviourByNames.poisonEnemy);
                this.addImpactToList(BehaviourByNames.sheepEnemy);
                this.addImpactToList(BehaviourByNames.cureSheep);
                this.addImpactToList(BehaviourByNames.curePoison);
                this.addImpactToList(BehaviourByNames.cureFreeze);
                this.addImpactToList(BehaviourByNames.cureFire);
                this.addImpactToList(BehaviourByNames.incBagSlot);
                this.addImpactToList(BehaviourByNames.autoTap);
                this.addImpactToList(BehaviourByNames.holdingTap);
                this.addImpactToList(BehaviourByNames.incHeroSize);
            },

            addImpactToList(type){
                let filterConfig = {
                    itemFilterChosen: [],
                    impactFilterChosen: type,
                };
                let count = ItemFilterUtils.getItemFilterByWord(this.pItemList, filterConfig).length;
                this.impactList.push({
                    impact: type,
                    count: count,
                    percent: this.getPercentView((count))
                });
            },

            getPercentView(count){
              return (count * 100 / this.filterCounter).toFixed(2)+'%';
            },
        }
    }
</script>

<style scoped>
    .scrollable-table-large {
        max-height: 655px; /* Set the max height */
        overflow-y: auto;  /* Enable vertical scrolling */
    }
</style>